import { render, staticRenderFns } from "./Yardages.vue?vue&type=template&id=579b8406&lang=html"
import script from "./Yardages.vue?vue&type=script&lang=js"
export * from "./Yardages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports